export type MinimapWheelMode = 'dispatch' | 'scroll'

function cloneWheelEvent(event: WheelEvent): WheelEvent {
  return new WheelEvent('wheel', {
    bubbles: false,
    cancelable: true,
    deltaX: event.deltaX,
    deltaY: event.deltaY,
    deltaZ: event.deltaZ,
    deltaMode: event.deltaMode,
    clientX: event.clientX,
    clientY: event.clientY,
    screenX: event.screenX,
    screenY: event.screenY,
    ctrlKey: event.ctrlKey,
    shiftKey: event.shiftKey,
    altKey: event.altKey,
    metaKey: event.metaKey,
  })
}

export function retargetMinimapWheel(
  target: HTMLElement,
  event: WheelEvent,
  mode: MinimapWheelMode
): void {
  if (mode === 'dispatch') {
    target.dispatchEvent(cloneWheelEvent(event))
    return
  }
  target.scrollBy({ left: event.deltaX, top: event.deltaY })
}

export function bindMinimapOverlayWheel(
  overlay: HTMLElement,
  getTarget: () => HTMLElement | null,
  getMode: () => MinimapWheelMode
): () => void {
  const onWheel = (event: WheelEvent) => {
    event.preventDefault()
    event.stopPropagation()
    const target = getTarget()
    if (!target) return
    retargetMinimapWheel(target, event, getMode())
  }
  overlay.addEventListener('wheel', onWheel, { passive: false })
  return () => overlay.removeEventListener('wheel', onWheel)
}
